

<router-outlet></router-outlet>


